import { render } from "./VerifiedStamp.vue?vue&type=template&id=4169c48a&scoped=true"
import script from "./VerifiedStamp.vue?vue&type=script&lang=js"
export * from "./VerifiedStamp.vue?vue&type=script&lang=js"

import "./VerifiedStamp.vue?vue&type=style&index=0&id=4169c48a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4169c48a"]])

export default __exports__